(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  class MColMenuFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      this.debouncedOnSubmit = debounce(function (event) {
        this.onSubmitHandler(event);
      }, 200);

      var form = this.querySelector('form');
      if (form) {
        // Fast path: apply checkbox/select changes immediately.
        form.addEventListener('change', this.onSubmitHandler.bind(this));

        // Slow path: debounce text inputs (price range).
        form.addEventListener('input', function (event) {
          var t = event && event.target;
          if (!t) return;
          if (t.matches && t.matches('input[type=\"text\"], input[type=\"search\"], input:not([type])')) {
            this.debouncedOnSubmit(event);
          }
        }.bind(this));
      }
    }

    static getRoot() {
      return document.querySelector('[data-m-col-menu-cards]');
    }

    static getSections() {
      var grid = document.getElementById('product-grid');
      if (!grid) return [];
      return [{ section: grid.dataset.id }];
    }

    static renderPage(searchParams, event, updateURLHash) {
      if (updateURLHash === undefined) updateURLHash = true;
      MColMenuFiltersForm.searchParamsPrev = searchParams;

      var gridContainer = document.getElementById('ProductGridContainer');
      if (!gridContainer) return;

      var collectionEl = gridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');

      var countDesktop = document.getElementById('ProductCountDesktop');
      var countMobile = document.getElementById('ProductCount');
      if (countDesktop) {
        var wrapD = countDesktop.closest('.m-col-menu-cards__results-count');
        if (wrapD) wrapD.classList.add('is-loading');
      }
      if (countMobile) {
        var wrapM = countMobile.closest('.m-col-menu-cards__results-count');
        if (wrapM) wrapM.classList.add('is-loading');
      }

      // Abort any in-flight fetch so rapid clicks feel instant.
      if (MColMenuFiltersForm.abortController) {
        try {
          MColMenuFiltersForm.abortController.abort();
        } catch (e) {}
      }
      MColMenuFiltersForm.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var fetchOpts = MColMenuFiltersForm.abortController ? { signal: MColMenuFiltersForm.abortController.signal } : undefined;

      MColMenuFiltersForm.getSections().forEach(function (section) {
        var url = window.location.pathname + '?section_id=' + section.section + '&' + searchParams;
        var cached = MColMenuFiltersForm.filterData.find(function (item) {
          return item.url === url;
        });
        if (cached) {
          MColMenuFiltersForm.renderFromHtml(cached.html, event);
        } else {
          fetch(url, fetchOpts)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              MColMenuFiltersForm.filterData.push({ html: html, url: url });
              MColMenuFiltersForm.renderFromHtml(html, event);
            })
            .catch(function (err) {
              // Ignore aborted requests when user clicks quickly.
              if (err && err.name === 'AbortError') return;
            });
        }
      });

      if (updateURLHash) MColMenuFiltersForm.updateURLHash(searchParams);
    }

    static renderFromHtml(html, event) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      MColMenuFiltersForm.renderFilters(parsed, event);
      MColMenuFiltersForm.renderProductGrid(parsed);
      MColMenuFiltersForm.renderProductCount(parsed);
    }

    static renderProductGrid(html) {
      var source = html.getElementById('ProductGridContainer');
      var target = document.getElementById('ProductGridContainer');
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
      document.dispatchEvent(new CustomEvent('m-col-menu-cards:grid-updated'));
    }

    static renderProductCount(html) {
      ['ProductCountDesktop', 'ProductCount'].forEach(function (id) {
        var source = html.getElementById(id);
        var target = document.getElementById(id);
        if (!source || !target) return;
        target.innerHTML = source.innerHTML;
        var wrap = target.closest('.m-col-menu-cards__results-count');
        if (wrap) wrap.classList.remove('is-loading');
      });
    }

    static renderFilters(html, event) {
      var sourceFilters = html.querySelectorAll('#FacetFiltersForm [data-m-filter-group]');
      var domFilters = document.querySelectorAll('#FacetFiltersForm [data-m-filter-group]');

      Array.from(domFilters).forEach(function (current) {
        if (current.hasAttribute('data-m-filter-static')) return;
        var stillExists = Array.from(sourceFilters).some(function (item) {
          return item.id === current.id;
        });
        if (!stillExists) current.remove();
      });

      var activeFilter = event && event.target ? event.target.closest('[data-m-filter-group]') : null;
      var activeFilterId = activeFilter ? activeFilter.id : '';

      sourceFilters.forEach(function (sourceEl, index) {
        if (sourceEl.id === activeFilterId) return;
        if (sourceEl.hasAttribute('data-m-filter-static')) return;
        var currentEl = document.getElementById(sourceEl.id);
        if (currentEl) {
          currentEl.innerHTML = sourceEl.innerHTML;
        } else {
          var previous = sourceFilters[index - 1];
          if (previous) {
            var prevDom = document.getElementById(previous.id);
            if (prevDom) prevDom.after(sourceEl.cloneNode(true));
          } else {
            var wrapper = document.getElementById('FacetsWrapperDesktop');
            if (wrapper) wrapper.prepend(sourceEl.cloneNode(true));
          }
        }
      });

      if (activeFilterId) {
        var countsSource = html.getElementById(activeFilterId);
        var countsTarget = document.getElementById(activeFilterId);
        if (countsSource && countsTarget) {
          MColMenuFiltersForm.renderCounts(countsSource, countsTarget);
        }
      }
    }

    static renderCounts(source, target) {
      var sourceSummary = source.querySelector('.m-col-menu-cards__filter-summary');
      var targetSummary = target.querySelector('.m-col-menu-cards__filter-summary');
      if (sourceSummary && targetSummary) targetSummary.outerHTML = sourceSummary.outerHTML;

      // 28.09.2026 Jarvis: link „Usuń filtr” przy grupie, w ktorej wlasnie kliknieto
      var staryUsun = target.querySelector('.m-col-menu-cards__usun-grupe');
      if (staryUsun) staryUsun.remove();
      var nowyUsun = source.querySelector('.m-col-menu-cards__usun-grupe');
      var summaryPo = target.querySelector('.m-col-menu-cards__filter-summary');
      if (nowyUsun && summaryPo) summaryPo.after(nowyUsun.cloneNode(true));

      var sourceHeader = source.querySelector('.m-col-menu-cards__filter-header');
      var targetHeader = target.querySelector('.m-col-menu-cards__filter-header');
      if (sourceHeader && targetHeader) targetHeader.outerHTML = sourceHeader.outerHTML;

      var sourceOptions = source.querySelector('.m-col-menu-cards__filter-options');
      var targetOptions = target.querySelector('.m-col-menu-cards__filter-options');
      if (sourceOptions && targetOptions) {
        var isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
        if (isShowingMore) {
          sourceOptions.querySelectorAll('.show-more-item.hidden').forEach(function (item) {
            item.classList.remove('hidden');
          });
        }
        targetOptions.outerHTML = sourceOptions.outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      history.pushState(
        { searchParams: searchParams },
        '',
        window.location.pathname + (searchParams ? '?' + searchParams : '')
      );
    }

    createSearchParams(form) {
      return new URLSearchParams(new FormData(form)).toString();
    }

    onSubmitHandler(event) {
      event.preventDefault();
      var form = event.target.closest('form');
      if (!form) return;
      MColMenuFiltersForm.renderPage(this.createSearchParams(form), event);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      var href = event.currentTarget.href;
      var searchParams = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
      MColMenuFiltersForm.renderPage(searchParams);
    }
  }

  MColMenuFiltersForm.filterData = [];
  MColMenuFiltersForm.searchParamsInitial = window.location.search.slice(1);
  MColMenuFiltersForm.searchParamsPrev = window.location.search.slice(1);
  MColMenuFiltersForm.abortController = null;

  if (!customElements.get('m-col-menu-filters-form')) {
    customElements.define('m-col-menu-filters-form', MColMenuFiltersForm);
  }

  if (!customElements.get('price-range')) {
    customElements.define(
      'price-range',
      class PriceRange extends HTMLElement {
        constructor() {
          super();
          this.querySelectorAll('input').forEach(function (input) {
            input.addEventListener('change', this.onRangeChange.bind(this));
            input.addEventListener('keydown', this.onKeyDown.bind(this));
          }, this);
          this.setMinAndMaxValues();
        }

        onRangeChange(event) {
          this.adjustToValidValues(event.currentTarget);
          this.setMinAndMaxValues();
        }

        onKeyDown(event) {
          if (event.metaKey) return;
          var pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
          if (!event.key.match(pattern)) event.preventDefault();
        }

        setMinAndMaxValues() {
          var inputs = this.querySelectorAll('input');
          var minInput = inputs[0];
          var maxInput = inputs[1];
          if (!minInput || !maxInput) return;
          if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
          if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
          if (minInput.value === '') maxInput.setAttribute('data-min', 0);
          if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
        }

        adjustToValidValues(input) {
          var value = Number(input.value);
          var min = Number(input.getAttribute('data-min'));
          var max = Number(input.getAttribute('data-max'));
          if (value < min) input.value = min;
          if (value > max) input.value = max;
        }
      }
    );
  }

  if (!customElements.get('facet-remove')) {
    customElements.define(
      'facet-remove',
      class FacetRemove extends HTMLElement {
        constructor() {
          super();
          var link = this.querySelector('a');
          if (!link) return;
          link.setAttribute('role', 'button');
          link.addEventListener('click', this.closeFilter.bind(this));
        }

        closeFilter(event) {
          event.preventDefault();
          var form = this.closest('m-col-menu-filters-form') || document.querySelector('m-col-menu-filters-form');
          if (form) {
            form.onActiveFilterClick(event);
            return;
          }

          // Fallback: if filters form is not present, navigate normally.
          if (event && event.currentTarget && event.currentTarget.href) {
            window.location.href = event.currentTarget.href;
          }
        }
      }
    );
  }

  if (!customElements.get('show-more-button')) {
    customElements.define(
      'show-more-button',
      class ShowMoreButton extends HTMLElement {
        constructor() {
          super();
          var button = this.querySelector('button');
          if (!button) return;
          button.addEventListener('click', this.expandShowMore.bind(this));
        }

        expandShowMore(event) {
          var parentDisplay = event.target.closest('.parent-display');
          if (!parentDisplay) return;
          this.querySelectorAll('.label-text').forEach(function (el) {
            el.classList.toggle('hidden');
          });
          parentDisplay.querySelectorAll('.show-more-item').forEach(function (item) {
            item.classList.toggle('hidden');
          });
          if (!this.querySelector('.label-show-less')) this.classList.add('hidden');
        }
      }
    );
  }

  window.addEventListener('popstate', function (event) {
    if (!document.querySelector('[data-m-col-menu-cards][data-m-filters-mode]')) return;
    var searchParams = event.state ? event.state.searchParams : MColMenuFiltersForm.searchParamsInitial;
    if (searchParams === MColMenuFiltersForm.searchParamsPrev) return;
    MColMenuFiltersForm.renderPage(searchParams, null, false);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-m-kontur-btn]');
    if (!btn) return;
    var pressed = btn.getAttribute('aria-pressed') === 'true';
    btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
  });
})();
